import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import { Vue2K18nNext } from '@k18n/vue2-k18n-next';
import { HotUpdate } from '@k18n/hot-update';
import { logPlugin } from '@kibt/weblogger/lib/directive-log';
import { PiniaVuePlugin, createPinia } from 'pinia';
import App from './index.vue';
import { rtlWatcherForK18n } from '@/utils/getLanguage';
import kwailog from '@/utils/kibtLogger';
import KImage from '@/components/common/KImage/KImage.vue';

const langs = require('@k18n/live-midyear/language/k18n/index.json');

Vue.use(logPlugin, {
    kwailog,
});
Vue.use(VueCompositionAPI);
Vue.use(Vue2K18nNext, {
    messages: [langs],
    plugins: [new HotUpdate()],
    rtl: {
        watcher: rtlWatcherForK18n,
    },
});

Vue.component('k-image', KImage);
Vue.use(PiniaVuePlugin);
const pinia = createPinia();


Vue.config.productionTip = false;

new Vue({
    render: h => h(App),
    pinia,
}).$mount('#app');
